import RepEvaluation from "@appdev/evaluations-ui/evaluations/rep";
import template from './program_evaluation.twig';
import { CustomModal } from "./customModal";

export default class ProgramEvaluation {
    constructor(meetingData, show_feedback_redirection_modal) {
        this.meetingId = meetingData.logistics_info.meeting_id;
        this.dom = $(twig({ data: template }).render({ topics: meetingData.speaker_info }))

        let mode = meetingData.eval.mode == 'eval_view' ? 'view' : 'default';
        this.show_feedback_redirection_modal = show_feedback_redirection_modal;
        this.evaluation = new RepEvaluation(mode);
        this.evaluation.fetch_evaluation_html(this.dom.find('#evals_container'), meetingData.logistics_info.meeting_id);
    }

    ready() {
        this.modal = new bootstrap.Modal(this.dom);
        this.modal.show();
        this.feedbackModal = new CustomModal({
          title: "Thank You!",
          content: `
            <p>
              <b>
                Thank you for closing out your program. We invite you to share more feedback 
                regarding the program, speaker, venue, or MedForce by using the Feedback Tool. 
                Please <a href="feedback" style="color:#0d6efd; text-decoration:underline;">
                click here</a> to go to the Feedback Tool now.
              </b>
            </p>
          `,
          buttons:[],
          close_callback: () => {
            if (app.appData.companyKey.toLowerCase().includes('allergan')) {
              app.navigate('attendance', [this.meetingId]);
            }
          }
        });

        $(this.dom).on("submit", "form[name=evaluation]", (event) => {
          event.preventDefault();
          let missing_required = this.evaluation.highlight_missing_required();
          if (missing_required) {
            this.dom.find(".evaluation_success_message").hide();
            this.dom.find(".missing_required_message").show();
            return;
          } else {
            this.dom.find(".evaluation_success_message").show();
            this.dom.find(".missing_required_message").hide();
            this.modal.hide();
            if (this.show_feedback_redirection_modal) {
              this.feedbackModal.open();
            }

            if (!this.show_feedback_redirection_modal && app.appData.companyKey.toLowerCase().includes('allergan')) {
              app.navigate('attendance', [this.meetingId]);
            }
          }
        });
    }
}
